// GraphQl
import { gql } from 'apollo-boost';

export const GET_REPORT_EXCEL = gql`
  query GetReportExcel(
    $search: String
    $fundId: ID
    $promoterId: ID
    $state: String
    $fromDate: Date
    $toDate: Date
  ) {
    contractsExcel(
      search: $search
      fundId: $fundId
      promoterId: $promoterId
      state: $state
      fromDate: $fromDate
      toDate: $toDate
    ) {
      success
      file
    }
  }
`;

export const LIST_PARTICIPANT_RAISING_ALL = gql`
  query listParticipantRaisingAll(
    $search: String
    $fundId: ID
    $promoterId: ID
    $state: String
    $fromDate: Date
    $toDate: Date
    $first: Int
    $last: Int
    $beforeCursor: String
    $afterCursor: String
  ) {
    listParticipantRaisingAll(
      search: $search
      fundId: $fundId
      promoterId: $promoterId
      state: $state
      fromDate: $fromDate
      toDate: $toDate
      first: $first
      last: $last
      before: $beforeCursor
      after: $afterCursor
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          numFee
          amount
          realAmount
          realNumFee
          createdDate
          updatedDate
          validated
          isApproved
          isVinculatedDirect
          isRopSync
          participationType
          keynuaSignedAt
          keynuaToken
          contractUploadedDate
          classFund {
            id
            name
          }
          lastParticipation {
            id
            order
            state
            participationPercentage
            contractGenerated
            contractEdited
            contractClientEdited
            contractApproved
            contractSigned
            contractUploaded
            coParticipants {
              edges {
                node {
                  participationPercentage
                  client {
                    user {
                      firstName
                      lastName
                      maternalSurname
                    }
                  }
                }
              }
            }
          }
          raising {
            id
            acronym
            fund {
              id
              businessName
              acronym
              currency {
                id
                symbol
              }
            }
          }
          client {
            id
            dataProcessingAuthorization
            propertyRegime {
              id
              society
            }
            maritalStatus {
              id
              spouse
            }
            address {
              id
              detail
              country {
                id
                name
              }
              county {
                id
                name
              }
              city {
                id
                name
              }
              district {
                id
                name
              }
            }
            promoter {
              id
              user {
                id
                firstName
                lastName
              }
            }
            coreConsultant {
              id
              user {
                id
                firstName
                lastName
              }
            }
            user {
              id
              userType
              firstName
              lastName
              maternalSurname
              documentNumber
              isVinculated
            }
          }
        }
      }
    }
  }
`;

export const GET_PARTICIPANT_RAISING = gql`
  query getParticipantRaising($id: ID!) {
    ParticipantRaising(id: $id) {
      id
      name
      numSent
      dateInitial
      dateEnd
      dateAward
      numToSend
      fundInvestors
      fundInvestorsPastWheel
      fundInvestorsOtherFunds
      interestedInvestors
    }
  }
`;

export const UPDATE_PARTICIPANT_RAISING = gql`
  mutation updateParticipantRaisingl(
    $id: ID!
    $input: ParticipantRaisingInput!
  ) {
    updateParticipantRaising(id: $id, input: $input) {
      wheel {
        id
        name
        numSent
        dateInitial
        dateEnd
        dateAward
        numToSend
        fundInvestors
        fundInvestorsPastWheel
        fundInvestorsOtherFunds
        interestedInvestors
      }
      errors {
        field
        message
      }
    }
  }
`;

export const DELETE_PARTICIPANT_RAISING = gql`
  mutation deleteParticipant($id: ID!) {
    deleteParticipant(id: $id) {
      participant {
        id
      }
      errors {
        field
        message
      }
    }
  }
`;

export const ADJUDICATE_PARTICIPANT_RAISING = gql`
  mutation adjudication($id: ID!) {
    adjudication(id: $id) {
      participation {
        id
        state
      }
    }
  }
`;

export const GENERATE_CONTRACT = gql`
  mutation generateParticipantContract($id: ID!) {
    generateParticipantContract(id: $id) {
      created
      error
    }
  }
`;

export const GENERATE_BLANK_CONTRACT = gql`
  mutation generateParticipantBlankContract($id: ID!) {
    generateParticipantBlankContract(id: $id) {
      created
      url
      error
    }
  }
`;

export const APPROVE_CONTRACT = gql`
  mutation approveParticipantContract($id: ID!) {
    approveParticipantContract(id: $id) {
      created
      error
    }
  }
`;

export const UPLOAD_CONTRACT = gql`
  mutation uploadParticipantContract(
    $id: ID!
    $file: Base64File!
    $uploadedDate: Date!
  ) {
    uploadParticipantContract(
      id: $id
      file: $file
      uploadedDate: $uploadedDate
    ) {
      created
      error
    }
  }
`;

export const EDIT_CONTRACT = gql`
  mutation editParticipantContract(
    $id: ID!
    $autorizo: Boolean!
    $spouseSign: Boolean!
  ) {
    editParticipantContract(
      id: $id
      autorizo: $autorizo
      spouseSign: $spouseSign
    ) {
      created
      error
      signingDocument {
        id
        signingProcess {
          id
          remuneraciones
          ahorro
          utilidades
          alquileres
          ventaAcciones
          ventaBienesInmuebles
          ventaBienesMuebles
          herencias
          prestamos
          otros
          otrosTexto
          explicacion
        }
      }
    }
  }
`;

export const VERIFY_PARTICIPANT_PAYMENT = gql`
  mutation updateParticipantStatusVerify($id: ID!) {
    updateParticipantStatusVerify(id: $id) {
      participant {
        id
        state
      }
    }
  }
`;

export const PARTICIPANT_RAISING_REPORT = gql`
  query participantRaisingReport($raising: ID) {
    participantRaisingReport(raisingId: $raising) {
      csv
      filename
    }
  }
`;

export const GET_PARTICIPANT_CONTRACT = gql`
  query contractPdf($participantId: ID) {
    contractPdf(participantId: $participantId) {
      pdf
      filename
    }
  }
`;

export const RAISING_ORDER = gql`
  query raisingOrder($raisingId: ID, $clientId: ID) {
    raisingOrder(raisingId: $raisingId, clientId: $clientId) {
      pdf
      filename
    }
  }
`;

export const UPDATE_SIGNATURE = gql`
  mutation updateSignature($id: ID!, $input: SigningProcessInput!) {
    updateSignature(id: $id, input: $input) {
      error
      signingDocument {
        id
        pdfSheet
        signedPdfSheet
        createdAt
        updatedAt
        dsSigningUrl
        dsUrls
        signingProcess {
          id
          signingFile
          isBiometricAvailable
          isContract
          clients {
            edges {
              node {
                id
                user {
                  id
                  username
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
      keynuaProcess {
        id
        contractId
        client {
          id
        }
        externalSigner {
          id
        }
        token
        state
        webhookMessage
      }
    }
  }
`;
